<template>
    <div id="app">
        <div id="particles-js"></div>
        <NavBar />
        <!--<div id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </div>-->
        <router-view/>
        <div style="background-color: #F0F0F8;height:40px;">
            <h6 style="text-align:center;color: rgba(0,0,0,1);font-size:19px;padding-top:7px" v-html="$t('copyright', [year])"></h6>
        </div>
    </div>
</template>

<style>
#app {
    color: #2c3e50;
}
</style>

<script>
import NavBar from '@/components/Header.vue'


export default {
    data () {
        return {
            name: 1,
            year: null,
            particle_config: null
        }
    },
    created:function(){
        var d = new Date();
        this.year = d.getFullYear();
    },
    components: {
        NavBar
    },
    mounted () {
        // eslint-disable-next-line
        particlesJS.load('particles-js', '/js/particle_config.json');
    }
}
</script>